import './collapsible.css'

export default function Collapsible({ title, children, isOpen = false, onToggle }) {
  return (
    <div className={`collapsible ${isOpen ? 'collapsible--open' : ''}`}>
      <button
        className='collapsible__button'
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className='collapsible__title'>{title}</span>
        <span className='collapsible__icon' aria-hidden='true' />
      </button>
      {isOpen && (
        <div className='collapsible__content'>
          {children}
        </div>
      )}
    </div>
  )
}
